import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  CUSTOM_ELEMENTS_SCHEMA,
  Renderer2,
  ChangeDetectionStrategy,
  HostListener
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ButtonModule } from 'primeng/button';
import { TreeModule } from 'primeng/tree';
import { DarkModeService } from './dark-mode.service';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../src/environments/environment';
import { InsightsService } from '../services/appinsightsservice';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    FooterComponent,
    PanelMenuModule,
    ButtonModule,
    TreeModule,
    ToastModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [InsightsService, MessageService],
})
export class AppComponent implements OnInit, OnDestroy {
  isDarkMode: boolean = false;
  loginDisplay: boolean = false;
  private readonly _destroying$ = new Subject<void>();
  menuItems: any[] = []; // Populate this with actual menu items
  isMinimized: boolean = false;
  treeNodes: any[] = [];
  isMobileView: boolean = false;

  constructor(
    // @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    // private authService: MsalService,
    // private msalBroadcastService: MsalBroadcastService,
    private darkModeService: DarkModeService,
    private renderer: Renderer2,
    private http: HttpClient,
    private router: Router,
    // private cnpAuthService: CNPAuthService
  ) { }

  async ngOnInit(): Promise<void> {
    this.initializeDarkMode();
    this.syncSelectedRegion(this.router.url);
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._destroying$),
      )
      .subscribe((event) => {
        this.syncSelectedRegion((event as NavigationEnd).urlAfterRedirects);
      });
    //this.authService.handleRedirectObservable().subscribe();
    //this.setLoginDisplay();

    //this.authService.instance.enableAccountStorageEvents(); // Optional: handle multi-tab events

    //this.listenForAccountChanges();
    //this.listenForAuthStatusChanges();
    //this.handleLoginSuccess();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  /** Initializes dark mode by subscribing to service and retrieving the saved theme from local storage */
  initializeDarkMode(): void {
    this.darkModeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });

    const savedTheme = localStorage.getItem('darkMode');
    this.isDarkMode = savedTheme === 'true'; // Convert string to boolean
  }

  /** Toggles dark mode and saves the state to local storage */
  toggleDarkMode(): void {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem('darkMode', this.isDarkMode.toString());
  }

  /** Sets login display based on account presence */
  //  setLoginDisplay(): void {
  //    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  //  }

  /** Checks and sets the active account if none is active */
  //  checkAndSetActiveAccount(): void {
  //    const activeAccount = this.authService.instance.getActiveAccount();
  //    const accounts = this.authService.instance.getAllAccounts();

  //    if (!activeAccount && accounts.length > 0) {
  //      this.authService.instance.setActiveAccount(accounts[0]);
  //    }
  //  }

  /** Toggles the sidebar visibility */
  toggleSidebar(): void {
    // this.isSidebarOpen = !this.isSidebarOpen;
  }

  /** Minimizes or expands the sidebar */
  toggleMinimize(): void {
    this.isMinimized = !this.isMinimized;
  }

  /** Listens for account addition or removal across tabs/windows */
  //  listenForAccountChanges(): void {
  //    this.msalBroadcastService.msalSubject$
  //      .pipe(
  //        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED)
  //      )
  //      .subscribe(() => {
  //        if (this.authService.instance.getAllAccounts().length === 0) {
  //          window.location.pathname = '/';
  //        } else {
  //          this.setLoginDisplay();
  //        }
  //      });
  //  }

  /** Listens for changes in the authentication status */
  //  listenForAuthStatusChanges(): void {
  //    this.msalBroadcastService.inProgress$
  //      .pipe(
  //        filter((status: InteractionStatus) => status === InteractionStatus.None),
  //        takeUntil(this._destroying$)
  //      )
  //      .subscribe(() => {
  //        this.setLoginDisplay();
  //        this.checkAndSetActiveAccount();
  //      });
  //  }

  /** Handles login success event */
  //  handleLoginSuccess(): void {
  //    this.msalBroadcastService.msalSubject$
  //      .pipe(
  //        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
  //      )
  //      .subscribe((result: EventMessage) => {
  //        const payload = result.payload as AuthenticationResult;
  //        this.authService.instance.setActiveAccount(payload.account);
  //      });
  //  }

  isMenuOpen = false;

  selectedRegion = 'Texas';
  routeType = 'enroll';
  regions = [
    'Texas',
    'Indiana'
  ];

  private syncSelectedRegion(url: string): void {
    const routeMatch = url.match(/^\/(enroll|outage)\/([^/?#]+)/);
    const routeType = routeMatch?.[1];
    const region = routeMatch?.[2];
    const selectedRegion = this.regions.find(
      (availableRegion) => availableRegion.toLowerCase() === region?.toLowerCase(),
    );

    if (routeType && selectedRegion) {
      this.routeType = routeType;
      this.selectedRegion = selectedRegion;
    }
  }

  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
  }

  selectRegion(region: string): void {
    const targetRoute = `/${this.routeType}/${region.toLowerCase()}`;
    this.selectedRegion = region;
    this.isMenuOpen = false;

    if (this.router.url === targetRoute) {
      this.router.navigateByUrl('/').then(() => {
        this.router.navigateByUrl(targetRoute);
      });
      return;
    }

    this.router.navigateByUrl(targetRoute);
  }

  @HostListener('document:click')
  closeMenu(): void {
    this.isMenuOpen = false;
  }
}
